import { FormattedMessage, useIntl } from 'react-intl'

import { RulesCard } from '@/pages/promotion/components/rules-card'
import { RulesList } from '@/pages/promotion/components/rules-list'

export const RakeRaceRules = () => {
  const { messages } = useIntl()

  const raw = messages['promo.rakeRace.rules.description'] as unknown
  const rules = Array.isArray(raw) ? (raw as string[]) : []

  if (!rules.length) {
    return null
  }

  return (
    <div className="mt-6">
      <RulesCard title={<FormattedMessage id="promo.rakeRace.rules.title" />}>
        <RulesList rules={rules} />
      </RulesCard>
    </div>
  )
}
